import { useState } from 'react'
import { useSessione } from 'context/SessioneProvider'
import useStateConSessione from 'utils/useStateConSessione'
import useStepApi from '../../Frontoffice/useStep'
import { SERVIZIO_DATI_CONDUCENTE } from '../utilDatiConducente'

export const STEPS = {
  INFORMATIVA: 'conducente_informativa',
  DATI_VERBALE: 'conducente_dati_verbale',
  DECURTAZIONE_PUNTI_COMPLETA: 'conducente_decurtazione_punti',
  CHIAVE_VERBALE: 'conducente_chiave_verbale',
}

const step_key_generators = {
  [STEPS.INFORMATIVA]: () => `datiConducente_informativa`,
  [STEPS.DATI_VERBALE]: (chiaveScelta) => `datiConducente_${chiaveScelta}_datiVerbaleVisti`,
  [STEPS.DECURTAZIONE_PUNTI_COMPLETA]: (chiaveScelta) => `datiConducente_${chiaveScelta}_decurtazionePuntiCompleta`,
  [STEPS.CHIAVE_VERBALE]: () => `datiConducente_chiaveScelta`,
}

const step_key_options = {
  [STEPS.INFORMATIVA]: () => ({}),
  [STEPS.DATI_VERBALE]: (chiaveScelta) => ({ rimuoviSe: !chiaveScelta }),
  [STEPS.DECURTAZIONE_PUNTI_COMPLETA]: (chiaveScelta) => ({ rimuoviSe: !chiaveScelta }),
  [STEPS.CHIAVE_VERBALE]: () => ({})
}

function keyMaker(step, chiaveScelta) {
  const fn = step_key_generators[step]
  if (!fn) {
    throw new Error(`Chiave non supportata: ${step}`)
  }
  // console.log(fn(chiaveScelta))
  return fn(chiaveScelta)
}

export function useRestoreStepVerbale() {
  const { getSteps } = useStepApi(SERVIZIO_DATI_CONDUCENTE)
  const { salvaInSessione } = useSessione()
  async function build(idPratica) {
    const resp = await getSteps(idPratica)
    if (resp.ok) {
      resp?.data?.data?.forEach(({ step, idPratica, extra }) => {
        if (![STEPS.DECURTAZIONE_PUNTI_COMPLETA].includes(step)) {
          salvaInSessione(keyMaker(step, idPratica), extra)
        }
      })
    }

  }

  return { build }
}

function useStepState(initialValue, step, chiaveVerbale, sendStepVerbale) {
  const key = keyMaker(step, chiaveVerbale)
  const options = step_key_options[step](chiaveVerbale)
  const [value, _setValue] = useStateConSessione(initialValue, key, options)

  const setter = (newValue) => {
    _setValue(newValue)
    sendStepVerbale?.(step, chiaveVerbale, newValue)
  }

  return [value, setter]
}

export default function useStepDatiConducente({
  codiceFiscale = null,
  chiaveVerbale,
  //chiaveScelta,
}) {
  const [chiaveScelta, setChiaveScelta] = useStepState(chiaveVerbale, STEPS.CHIAVE_VERBALE, chiaveVerbale, sendStepDatiConducente, codiceFiscale)
  const [informativaAccettata, setInformativaAccettata] = useStepState(false, STEPS.INFORMATIVA, chiaveScelta, sendStepDatiConducente, codiceFiscale)
  const [datiVerbaleVisti, setDatiVerbaleVisti] = useStepState(false, STEPS.DATI_VERBALE, chiaveScelta, sendStepDatiConducente, codiceFiscale)
  const [decurtazionePuntiCompleta, setDecurtazionePuntiCompleta] = useStepState(false, STEPS.DECURTAZIONE_PUNTI_COMPLETA, chiaveScelta, sendStepDatiConducente, codiceFiscale)

  const { sendSteps } = useStepApi(SERVIZIO_DATI_CONDUCENTE)

  const [stepIncompleti, setStepIncompleti] = useState({})

  function sendStepDatiConducente(step, chiave, data) {
    if (codiceFiscale) {
      if (!chiave) {
        setStepIncompleti(prev => {
          const key = `${step}_${codiceFiscale}`
          if (prev[key]?.data === data) return prev
          return { ...prev, [key]: { step, codiceFiscale, chiave, data } }
        })

      } else { // keyMaker lo si fa adesso o quando si torna e si ricostruisce lo stato, forse + pulita la seconda

        let steps = []
        Object.keys(stepIncompleti).forEach((key) =>
          steps.push({ step: stepIncompleti[key].step, idPratica: chiave, extra: stepIncompleti[key].data })
        )
        steps.push({ step: step, idPratica: chiave, extra: data })

        sendSteps(steps)
      }
    }
  }

  return {
    informativaAccettata,
    setInformativaAccettata,

    chiaveScelta,
    setChiaveScelta,

    datiVerbaleVisti,
    setDatiVerbaleVisti,

    decurtazionePuntiCompleta,
    setDecurtazionePuntiCompleta,
  }
}